import PRODUCT_LIST from '../../types/product-list'
import { SESSION_STORAGE } from './shared'

const updateProductPrice = (productsList, productPriceUpdate) => {
  if (productsList.filter(product => product.id === productPriceUpdate.id).length > 0) {
    productsList.map(product => {
      if (product.id === productPriceUpdate.id) {
        product = productPriceUpdate
      }
    })
  } else {
    productsList.push(productPriceUpdate)
  }

}

export default {
  [PRODUCT_LIST.MUTATIONS.SET_PRODUCT_PRICE]: ({products}, productPriceUpdate) => {
    updateProductPrice(products, productPriceUpdate)

    if (sessionStorage) {
      sessionStorage.setItem(SESSION_STORAGE.productList, JSON.stringify(products))
    }
  },
}
